<div [class.loading]="loader.loading">
  <div *ngIf="quickquote$ | async as quickquote">
    <div class="bootstrap lead-gen">
      <ng-container *ngIf="quickquote$ | async as quickquote">
        <div class="lead-gen__card" *ngIf="!quickquote">Questionnaire {{ name }} not found</div>

        <ng-container *ngIf="quickquote">
          <div class="lead-gen__body" [ngSwitch]="quickquote.currentPage?.type">
            <app-apg-lead-gen-page
              *ngSwitchDefault
              [page]="quickquote.currentPage"
              [firstPage]="quickquote.currentPageIndex === 0"
              (opened)="open($event)">
            </app-apg-lead-gen-page>

            <app-apg-lead-gen-complete *ngSwitchCase="'Complete'" [quickQuote]="quickquote" [page]="quickquote.currentPage">
            </app-apg-lead-gen-complete>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<div class="apg-panel loader">
  <div class="loading" *ngIf="!error">
    <div class="invalid-feedback">Please wait...</div>
    <ion-spinner></ion-spinner>
  </div>
  <div class="loading" *ngIf="error">
    <div class="invalid-feedback" [innerHTML]="error"></div>
  </div>
</div>
